import { render, staticRenderFns } from "./programPopup.vue?vue&type=template&id=06258b4b&scoped=true&"
import script from "./programPopup.vue?vue&type=script&lang=js&"
export * from "./programPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06258b4b",
  null
  
)

export default component.exports